const ContactFormCategory: string = "Contact Form";

export default ContactFormCategory;
